import { useRef, useState } from 'react'
import { useLazyQuery } from '@apollo/client'
import {
  EMPLOYEE_LOOKUP_WITH_PH_FLAG,
  IEmployeeLookupRequest,
  IEmployeeLookupWithPhFlagResponse,
} from 'queries/employee-lookup'

export const useEmployeeLookupWithPhFlag = () => {
  const [loadEmployees, setLoadEmployees] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const debounceRef = useRef<NodeJS.Timeout | null>(null)

  const [getEmployees] = useLazyQuery<IEmployeeLookupWithPhFlagResponse, IEmployeeLookupRequest>(
    EMPLOYEE_LOOKUP_WITH_PH_FLAG,
    {
      fetchPolicy: 'no-cache',
      onCompleted: (employees) => {
        setIsLoading(false)
        const emps = employees?.employeeListWithPhFlag?.employees || []
        setLoadEmployees(emps)
      },
      onError: (error) => {
        setIsLoading(false)
        setLoadEmployees([])
        console.warn('Employee lookup error:', error)
      },
    }
  )

  const searchEmployees = (
    value: string,
    processSearchString: (v: string) => string,
    removeSpacesAfterComma: (v: string) => string
  ) => {
    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }
    debounceRef.current = setTimeout(() => {
      if (value.trim().length > 0) {
        setIsLoading(true)
        getEmployees({
          variables: {
            employeeSearchRequest: {
              searchKey: removeSpacesAfterComma(processSearchString(value)),
              sortBy: 'firstName',
            },
          },
        })
      } else {
        setLoadEmployees([])
        setIsLoading(false)
      }
    }, 500)
  }

  const clearSearch = () => {
    setLoadEmployees([])
    setIsLoading(false)
  }

  return {
    loadEmployees,
    isLoading,
    searchEmployees,
    clearSearch,
    debounceRef,
    setLoadEmployees,
  }
}
